import { render } from "./TrendsView.vue?vue&type=template&id=28902227&scoped=true"
import script from "./TrendsView.vue?vue&type=script&lang=js"
export * from "./TrendsView.vue?vue&type=script&lang=js"

import "./TrendsView.vue?vue&type=style&index=0&id=28902227&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28902227"]])

export default __exports__